import MobileLayout from "../mobile";
import verificationImage from "../../assests/page/verify-kyc.svg";
import React, { useEffect, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";
import useUserStore from "../../store/userSlice";
import useNetworkStore from "../../store/networkStore";
import { useNavigate } from "react-router-dom";
import { errorToast, KYCTexts } from "../../utils/constants";
import {
  createAccessTokenForNewUser,
  fetchUserDetailsFromSumsub,
  fixApplicantRejections,
} from "../../utils/helpers/kyc";
import KYCQuestionnaire from "../../components/popups/questionnaire";
import { hashTheString } from "@verified-network/verified-custody";
import {
  decryptUserKycData,
  saveUserKycQuestionaire,
} from "../../utils/helpers/utils";
import { useWalletSelector } from "@near-wallet-selector/react-hook";
import { useConnector } from "@solana-commerce/connector";
import { VerifiedWallet } from "@verified-network/verified-sdk";

const MobileKYCPage = (props) => {
  const {
    accessToken,
    setPageAction,
    allCountries,
    pendingQuestionaire,
    setKycQuestionaire,
  } = props.generalDataProps;

  const [tokenToUse, setTokenToUse] = useState(accessToken);
  const [showSumsubPortal, setShowSumsubPortal] = useState(
    props.showSumsubPortal || false,
  );
  const [kycCompleted, setKycCompleted] = useState(props?.isComplete || false);
  const [kycError, setKycError] = useState(props?.isError || false);
  const [showRejectionText, setShowRejectionText] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [newApplicantId, setNewApplicantId] = useState("");
  const [linkToUse, setLinkToUse] = useState("");
  const [decryptedQuestionaire, setDecryptedQuestionaire] = useState({});
  const { signedAccountId } = useWalletSelector();
  const { accounts } = useConnector();
  const { userAddress, accessToken: _accessToken } = useUserStore();
  const { chainId, signer, name, provider } = useNetworkStore();

  const navigate = useNavigate();

  useEffect(() => {
    const generateNewAccessToken = async () => {
      if (_accessToken?.length === 0) {
        const accessTokenRes = await createAccessTokenForNewUser(
          signedAccountId?.length > 0
            ? VerifiedWallet.createWallet()?.address
            : accounts[0]?.address?.length > 0
              ? VerifiedWallet.createWallet()?.address
              : userAddress,
          signedAccountId?.length > 0
            ? `397-${signedAccountId}`
            : accounts[0]?.address?.length > 0
              ? `397-${accounts[0]?.address}`
              : chainId,
          props.additionalProps?.isOtp ? true : null,
        );
        setTokenToUse(accessTokenRes?.accessToken);
      } else {
        setTokenToUse(_accessToken);
      }
    };
    if (!accessToken || accessToken === "") {
      generateNewAccessToken();
    }
  }, [
    _accessToken,
    accessToken,
    accounts,
    chainId,
    props.additionalProps?.isOtp,
    signedAccountId,
    userAddress,
  ]);

  const sumsubConfig = {
    lang: "en",
    theme: "light",
    i18n: {
      document: {
        subTitles: {
          IDENTITY: "Upload a document that proves your identity",
        },
      },
    },
  };

  return (
    <MobileLayout>
      <div
        style={{ gap: "55px", marginBottom: "50px" }}
        className="gp-mobile-kyc"
      >
        <div className="gp-mobile-kyc-container">
          {!showSumsubPortal && (
            <>
              <img
                alt="KYC Verification"
                src={verificationImage}
                className="verify-kyc-image"
              />
              <div className="gp-mobile-kyc-content">
                <p className="gp-mobile-kyc-content-title">KYC Incomplete</p>

                {Object.keys(pendingQuestionaire)?.length === 0 && (
                  <p className="gp-mobile-kyc-content-label">
                    KYC not completed, Please complete your KYC to activate your
                    wallet.
                  </p>
                )}
                {Object.keys(pendingQuestionaire)?.length > 0 && (
                  <p className="gp-mobile-kyc-content-label">
                    You have a pending KYC application. Please click “Resume
                    KYC” and sign the message in your wallet to continue from
                    where you left off.
                  </p>
                )}
              </div>
            </>
          )}

          {showSumsubPortal && (
            <>
              {kycCompleted && (
                <div className="gp-mobile-kyc-content">
                  <p className="gp-mobile-kyc-content-title">KYC Completed</p>
                </div>
              )}

              {kycCompleted && (
                <div className="gp-mobile-kyc-content">
                  <p
                    style={{ wordWrap: "break-word" }}
                    className="gp-mobile-kyc-content-title"
                  >
                    Thank you for completing your KYC. You will receive an email
                    after your KYC submission is approved.
                  </p>
                  <p
                    style={{ wordWrap: "break-word" }}
                    className="verify-kyc-footer-text"
                  >
                    After KYC approval, you can add funds to your account with
                    Debit/Card cards or your Bank to use Verified Network.
                  </p>
                </div>
              )}
              {kycError && (
                <div className="gp-mobile-kyc-content">
                  <p className="gp-mobile-kyc-content-title">
                    Unexpected Error!
                  </p>
                </div>
              )}
              {!kycCompleted && !kycError && tokenToUse?.length > 0 && (
                <SumsubWebSdk
                  accessToken={tokenToUse}
                  expirationHandler={() =>
                    Promise.resolve(
                      createAccessTokenForNewUser(userAddress, chainId).then(
                        (res) => res?.accessToken,
                      ),
                    )
                  }
                  config={sumsubConfig}
                  options={{ addViewportTag: true, adaptIframeHeight: true }}
                  onMessage={async (msg, payload) => {
                    if (
                      msg === "idCheck.applicantStatus"
                      // payload?.reviewResult?.reviewAnswer?.toLowerCase() === "red"
                    ) {
                      // setKycCompleted(true);
                      setPageAction("Authentication");
                      props.setPopupContentPosition("center");
                      props.setPopupContent(
                        <KYCQuestionnaire
                          countryList={Object.values(allCountries)}
                          generalDataProps={props.generalDataProps}
                          hashedUserAddress={hashTheString(
                            props?.additionalProps?.userAddress,
                          )}
                          hashedUserId={hashTheString("")}
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setCustomLoading={props.setCustomLoading}
                          additionalProps={props.additionalProps}
                          mobileScreen={true}
                          mobileAction={{
                            setKycCompleted,
                            setKycError,
                            setShowSumsubPortal,
                          }}
                          KYCQuestionnaire={decryptedQuestionaire}
                        />,
                      );
                      props.setShowPopup(true);
                    } else if (msg === "idCheck.onApplicantLoaded") {
                      const applicantId = payload?.applicantId;
                      setNewApplicantId(applicantId);
                    } else if (msg === "idCheck.onApplicantSubmitted") {
                      // setKycCompleted(true);
                      setPageAction("Authentication");
                      props.setPopupContentPosition("center");
                      props.setPopupContent(
                        <KYCQuestionnaire
                          countryList={Object.values(allCountries)}
                          generalDataProps={props.generalDataProps}
                          hashedUserAddress={hashTheString(
                            props?.additionalProps?.userAddress,
                          )}
                          hashedUserId={hashTheString("")}
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setCustomLoading={props.setCustomLoading}
                          additionalProps={props.additionalProps}
                          mobileScreen={true}
                          mobileAction={{
                            setKycCompleted,
                            setKycError,
                            setShowSumsubPortal,
                          }}
                          KYCQuestionnaire={decryptedQuestionaire}
                        />,
                      );
                      props.setShowPopup(true);
                    } else if (
                      payload?.reviewResult?.reviewAnswer?.length > 0
                    ) {
                      setPageAction("Authentication");
                      props.setPopupContentPosition("center");
                      props.setPopupContent(
                        <KYCQuestionnaire
                          countryList={Object.values(allCountries)}
                          generalDataProps={props.generalDataProps}
                          hashedUserAddress={hashTheString(
                            props?.additionalProps?.userAddress,
                          )}
                          hashedUserId={hashTheString("")}
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setCustomLoading={props.setCustomLoading}
                          additionalProps={props.additionalProps}
                          mobileScreen={true}
                          mobileAction={{
                            setKycCompleted,
                            setKycError,
                            setShowSumsubPortal,
                          }}
                          KYCQuestionnaire={decryptedQuestionaire}
                        />,
                      );
                      props.setShowPopup(true);
                      // const kycRes = await getUserKYCDetailsWeb3(
                      //   chainId,
                      //   userAddress,
                      //   web3
                      // );
                      // setKycCompleted(true);
                      // if (Number(kycRes?.userKycStatus) !== 3) {
                      //   //always verify user is not approved before show rejections
                      //   if (
                      //     payload?.reviewResult?.reviewAnswer?.toLowerCase() ===
                      //       "red" &&
                      //     payload?.reviewResult?.reviewRejectType?.toLowerCase() ===
                      //       "final"
                      //   ) {
                      //     setRejectionMessage(
                      //       payload?.reviewResult?.moderationComment?.length > 0
                      //         ? payload?.reviewResult?.moderationComment
                      //         : KYCTexts.underReview
                      //     );
                      //   }
                      //   if (
                      //     payload?.reviewResult?.reviewAnswer?.toLowerCase() ===
                      //       "red" &&
                      //     payload?.reviewResult?.reviewRejectType?.toLowerCase() !==
                      //       "final"
                      //   ) {
                      //     setRejectionMessage(
                      //       payload?.reviewResult?.moderationComment?.length > 0
                      //         ? payload?.reviewResult?.moderationComment
                      //         : KYCTexts.resubmission
                      //     );
                      //   }
                      // }
                    }
                  }}
                  onError={(data) => setKycError(true)}
                />
              )}

              {!kycCompleted && !kycError && linkToUse?.length > 0 && (
                <iframe
                  title="KYC Resubmission"
                  src={linkToUse}
                  width="100%"
                  height="550px"
                ></iframe>
              )}
            </>
          )}
        </div>

        {!showSumsubPortal && (
          <React.Fragment>
            {Object.keys(pendingQuestionaire)?.length === 0 && (
              <button
                style={{ marginBottom: "85px" }}
                onClick={(e) => {
                  if (
                    e.target.className.includes("startup-button") &&
                    e.target.className !== "startup-button"
                  ) {
                    e.target.className = "startup-button-click";
                    setShowSumsubPortal(true);
                  } else {
                    const buttonElement = document.getElementsByClassName(
                      "startup-button-active",
                    );
                    if (buttonElement.length > 0) {
                      buttonElement[0].className = "startup-button-click";
                      setShowSumsubPortal(true);
                    }
                  }
                }}
                className="startup-button-active"
              >
                <p className="st-button-text">Complete KYC</p>
              </button>
            )}
            {Object.keys(pendingQuestionaire)?.length > 0 && (
              <button
                style={{ marginBottom: "85px" }}
                onClick={async (e) => {
                  if (
                    e.target.className.includes("startup-button") &&
                    e.target.className !== "startup-button"
                  ) {
                    e.target.className = "startup-button-click";
                    try {
                      props.setShowPopup(true);
                      props.setCustomLoading(true);
                      //save DB questionaire first
                      if (
                        !pendingQuestionaire?.shouldSave ||
                        !pendingQuestionaire?.shouldSave?.notSave
                      ) {
                        console.log("Pending is local will save first");
                        const { saved, signature, nonce, nearNonce } =
                          await saveUserKycQuestionaire(
                            userAddress,
                            chainId,
                            name,
                            signer,
                            provider,
                            pendingQuestionaire,
                            hashTheString(userAddress),
                            false,
                            true,
                          );
                        if (saved) {
                          const userQuestionaire = await decryptUserKycData(
                            userAddress,
                            chainId,
                            name,
                            signer,
                            signature,
                            nonce,
                            nearNonce,
                          );

                          setKycQuestionaire(userQuestionaire || {});
                          setDecryptedQuestionaire(userQuestionaire || {});
                          setShowSumsubPortal(true);
                        }
                      } else {
                        console.log("Pending is DB will just decrypt");
                        //skip save and decrypt if pending questionaire is from DB
                        const userQuestionaire = await decryptUserKycData(
                          userAddress,
                          chainId,
                          name,
                          signer,
                        );

                        setKycQuestionaire(userQuestionaire || {});
                        setDecryptedQuestionaire(userQuestionaire || {});

                        setShowSumsubPortal(true);
                      }

                      props.setShowPopup(false);
                      props.setCustomLoading(false);
                    } catch (err) {
                      props.setShowPopup(false);
                      props.setCustomLoading(false);
                    }
                  } else {
                    const buttonElement = document.getElementsByClassName(
                      "startup-button-active",
                    );
                    if (buttonElement.length > 0) {
                      buttonElement[0].className = "startup-button-click";
                      try {
                        props.setShowPopup(true);
                        props.setCustomLoading(true);
                        //save DB questionaire first
                        if (
                          !pendingQuestionaire?.shouldSave ||
                          !pendingQuestionaire?.shouldSave?.notSave
                        ) {
                          console.log("Pending is local will save first");
                          const { saved, signature, nonce, nearNonce } =
                            await saveUserKycQuestionaire(
                              userAddress,
                              chainId,
                              name,
                              signer,
                              provider,
                              pendingQuestionaire,
                              hashTheString(userAddress),
                              false,
                              true,
                            );
                          if (saved) {
                            const userQuestionaire = await decryptUserKycData(
                              userAddress,
                              chainId,
                              name,
                              signer,
                              signature,
                              nonce,
                              nearNonce,
                            );

                            setKycQuestionaire(userQuestionaire || {});
                            setDecryptedQuestionaire(userQuestionaire || {});
                            setShowSumsubPortal(true);
                          }
                        } else {
                          console.log("Pending is DB will just decrypt");
                          //skip save and decrypt if pending questionaire is from DB
                          const userQuestionaire = await decryptUserKycData(
                            userAddress,
                            chainId,
                            name,
                            signer,
                          );

                          setKycQuestionaire(userQuestionaire || {});
                          setDecryptedQuestionaire(userQuestionaire || {});

                          setShowSumsubPortal(true);
                        }

                        props.setShowPopup(false);
                        props.setCustomLoading(false);
                      } catch (err) {
                        props.setShowPopup(false);
                        props.setCustomLoading(false);
                      }
                    }
                  }
                }}
                className="startup-button-active"
              >
                <p className="st-button-text">Resume KYC</p>
              </button>
            )}
          </React.Fragment>
        )}
        {showSumsubPortal && kycError && (
          <button
            style={{ marginBottom: "85px" }}
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                setShowSumsubPortal(false);
                setKycError(false);
                navigate("/");
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  setShowSumsubPortal(false);
                  setKycError(false);
                  navigate("/");
                }
              }
            }}
            className="startup-button-active"
          >
            <p className="st-button-text">Close</p>
          </button>
        )}
        {showSumsubPortal && !kycError && kycCompleted && (
          <>
            {rejectionMessage?.length > 0 && (
              <>
                {!showRejectionText && (
                  // <button
                  //   onClick={() => {
                  //     if (rejectionMessage?.length > 0) {
                  //       setShowRejectionText(true);
                  //     }
                  //   }}
                  //   className="verify-kyc-button-back"
                  // >
                  //   <p className="verify-kyc-button-back-text">
                  //     Check Rejection
                  //   </p>
                  // </button>

                  <button
                    style={{
                      background: "unset",
                      border: "1px solid var(--Neutral-950, #0c0c0e)",
                      marginBottom: "0",
                    }}
                    onClick={async () => {
                      if (rejectionMessage?.length > 0) {
                        setShowRejectionText(true);
                      }
                    }}
                    className="startup-button-active"
                  >
                    <p className="st-button-text">Check Rejection</p>
                  </button>
                )}
                {showRejectionText && (
                  // <button
                  // onClick={async () => {
                  //   if (rejectionMessage?.length > 0 && newApplicantId) {
                  //     props.setCustomLoading(true);
                  //     const oldDetails = await fetchUserDetailsFromSumsub(
                  //       newApplicantId
                  //     );
                  //     const link = await fixApplicantRejections(
                  //       newApplicantId,
                  //       oldDetails?.externalUserId
                  //     );
                  //     if (link?.length > 0) {
                  //       setLinkToUse(link);
                  //       setTokenToUse("");
                  //       setShowRejectionText(false);
                  //       setRejectionMessage("");
                  //       setKycError(false);
                  //       setKycCompleted(false);

                  //       props.setCustomLoading(false);
                  //     } else {
                  //       errorToast(
                  //         "Oops something went wrong",
                  //         "Unable to update your previous KYC submission. Try again later"
                  //       );
                  //       props.setCustomLoading(false);
                  //     }
                  //   }
                  // }}
                  //   className="verify-kyc-button-back"
                  // >
                  //   <p className="verify-kyc-button-back-text">Fix Rejection</p>
                  // </button>

                  <>
                    {showRejectionText && rejectionMessage?.length > 0 && (
                      <p
                        style={{
                          width: "90%",
                          color: "red",
                          marginTop: "5px",
                          marginBottom: "5px",
                        }}
                        className="verify-kyc-footer-text"
                      >
                        {rejectionMessage?.replace(
                          "If you have any questions, contact the company you're verifying with compliance@verified.network",
                          "Please click on 'Fix Rejection' to update and resubmit your profile.",
                        )}
                      </p>
                    )}
                    <button
                      style={{
                        background: "unset",
                        border: "1px solid var(--Neutral-950, #0c0c0e)",
                        marginBottom: "0",
                      }}
                      onClick={async () => {
                        if (rejectionMessage?.length > 0 && newApplicantId) {
                          props.setShowPopup(true);
                          props.setCustomLoading(true);
                          const oldDetails =
                            await fetchUserDetailsFromSumsub(newApplicantId);
                          const link = await fixApplicantRejections(
                            newApplicantId,
                            oldDetails?.externalUserId,
                          );
                          if (link?.length > 0) {
                            setLinkToUse(link);
                            setTokenToUse("");
                            setShowRejectionText(false);
                            setRejectionMessage("");
                            setKycError(false);
                            setKycCompleted(false);
                            props.setShowPopup(false);
                            props.setCustomLoading(false);
                          } else {
                            errorToast(
                              "Oops something went wrong",
                              "Unable to update your previous KYC submission. Try again later",
                            );
                            props.setShowPopup(false);
                            props.setCustomLoading(false);
                          }
                        }
                      }}
                      className="startup-button-active"
                    >
                      <p className="st-button-text">Fix Rejection</p>
                    </button>
                  </>
                )}

                <button
                  style={{ marginBottom: "85px" }}
                  onClick={() => {
                    props.setShowPopup(false);
                    props.setPopupContent(null);
                    props.setPopupContentPosition("center");
                    setShowSumsubPortal(false);
                    setKycCompleted(false);
                    setRejectionMessage("");
                    setShowRejectionText(false);
                    navigate("/");
                  }}
                  className="startup-button-active"
                >
                  <p className="st-button-text">Close</p>
                </button>
              </>
            )}
            {rejectionMessage === "" && (
              <button
                style={{ marginBottom: "85px" }}
                onClick={(e) => {
                  if (
                    e.target.className.includes("startup-button") &&
                    e.target.className !== "startup-button"
                  ) {
                    e.target.className = "startup-button-click";
                    setShowSumsubPortal(false);
                    setKycCompleted(false);
                    setRejectionMessage("");
                    setShowRejectionText(false);
                    navigate("/");
                  } else {
                    const buttonElement = document.getElementsByClassName(
                      "startup-button-active",
                    );
                    if (buttonElement.length > 0) {
                      buttonElement[0].className = "startup-button-click";
                      setShowSumsubPortal(false);
                      setKycCompleted(false);
                      setRejectionMessage("");
                      setShowRejectionText(false);
                      navigate("/");
                    }
                  }
                }}
                className="startup-button-active"
              >
                <p className="st-button-text">Close</p>
              </button>
            )}
          </>
        )}
        {showSumsubPortal &&
          !kycCompleted &&
          !kycError &&
          linkToUse?.length > 0 && (
            <button
              style={{ marginBottom: "85px" }}
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                props.setPopupContentPosition("center");
                setShowSumsubPortal(false);
                setKycError(false);
                setLinkToUse("");
                setRejectionMessage("");
                setShowRejectionText(false);
                navigate("/");
              }}
              className="startup-button-active"
            >
              <p className="st-button-text">Close</p>
            </button>
          )}
      </div>
    </MobileLayout>
  );
};

export default MobileKYCPage;
